<template>
    <template v-for="(key, index) in Object.keys(models)" :key="index">
        <row v-if="!models[key].delete" class="flex wrap center vcenter">
            <MetaBox :meta="{
                key: '_base',
                name: 'شاخص',
                type: 'selector',
                extras: `${extras}`
            }" :vm="models[key]['_base']" @onchange="(obj) => this.models[`R${index}`][obj.key] = obj.value">
            </MetaBox>
            <template
                v-for="(meta, i) in metas.filter((meta) => { return meta.key === this.models[`R${index}`]['_base'] })"
                :key="i">
                <Switch v-if="meta?.type === 'switch'" :meta="meta" :vm="models[key][this.models[`R${index}`]['_base']]" @onchange="(obj) => this.models[`R${index}`][obj.key] = obj.value">
                </Switch>
                <MetaBox v-else :meta="meta" :vm="models[key][this.models[`R${index}`]['_base']]" :internal="true"
                    @onchange="(obj) => this.models[`R${index}`][obj.key] = obj.value">
                </MetaBox>
            </template>
            <div class="controls flex wrap center vcenter">
                <img v-if="this.metas?.length !== length" v-lazy="'/images/plus.webp'" width="24" height="24" alt="add"
                    loading="lazy" @click="add">
                <img v-if="length > 1" v-lazy="'/images/xmark.webp'" width="24" height="24" alt="delete" loading="lazy"
                    @click="() => {
                        models[key] = { delete: true }
                    }">
            </div>
        </row>
    </template>
    <div class="options flex center">
        <Option :color="'blue'" :icon="'fe-search'" :name="'جست و جو'" @onclick="onclick"></Option>
        <Option :color="'red'" :icon="'fe-x'" :name="'حذف مقادیر'" @onclick="clear"></Option>
    </div>
</template>

<script>
/* eslint-disable */
import { defineAsyncComponent } from 'vue'

import Switch from '../Form/Inputs/Switch.vue'
import Option from '../Form/Option.vue'

export default {
    name: 'Search',
    props: ['data'],
    inject: ['base'],
    components: {
        MetaBox: defineAsyncComponent(() => import('../Form/Inputs/MetaBox.vue')),
        Switch,
        Option
    },
    computed: {
        entity_type() {
            return this.data?.entity_type
        }
    },
    created() {
        this.init()
    },
    data() {
        return {
            metas: [],
            extras: '',
            models: {},
            length: 0,
        }
    },
    watch: {
        entity_type(newEntity, oldEntity) {
            this.init()
        },
        models: {
            handler(newModels, oldModels) {
                this.length = 0
                Object.keys(this.models).forEach(key => {
                    if (!this.models[key].delete)
                        this.length += 1
                })
            },
            deep: true
        }
    },
    methods: {
        init() {
            this.models = {}
            this.metas = this.data?.metas?.filter((meta) => {
                return meta.entity_type === this.data.entity_type?.toUpperCase()
                    && !['avatar', 'files', 'file', 'tab', 'step'
                        , 'password', 'multiparams', 'span', 'space'
                        , 'button'].includes(meta.type)
            })

            this.metas.forEach((meta) => {
                if (meta.type === 'textarea')
                    meta.type = 'text'
            })
            this.extra()
            this.add()
        },
        add() {
            let keys = Object.keys(this.models)
            let index = this.base.Util().validate(keys)
                ? Number(keys[keys.length - 1].replaceAll('R', '')) + 1
                : 0
            this.models[`R${index}`] = { _base: `${this.extras.split(';')[this.length].split(',')[0].split('=')[1]}` }
        },
        extra() {
            let index = 0
            this.extras = ''
            this.metas.forEach(meta => {
                this.extras += `R${index}:key=${meta.key},value=${meta.name};`
                index += 1
            })
        },
        onclick(obj) {
            let query = {}
            if (this.$route.query)
                for (const key of Object.keys(this.$route.query))
                    query[key] = this.$route.query[key]
            for (const key of Object.keys(this.models))
                if (!this.models[key].delete) {
                    let value = this.models[key][this.models[key]['_base']]
                    if (this.base.Util().validate(value))
                        query[this.models[key]['_base']] = value
                }
            this.$router.push({ path: window.location.pathname.replaceAll(`/${this.$route.params.page}/${this.$route.params.size}`, '/1/15'), query: query, params: { entity_type: this.data.entity_type, page: 1, size: 15 } })
            this.$emit('onresult', obj)
        },
        clear() {
            this.$router.push({ path: window.location.pathname.replaceAll(`/${this.$route.params.page}/${this.$route.params.size}`, '/1/15'), params: { entity_type: this.data.entity_type, page: 1, size: 15 } })
            this.$emit('onresult', {})
        }
    }
}
</script>

<style scoped src="../../assets/css/components/dialogs/search.css"></style>